import { Link } from "react-router-dom";
import { resolveImg } from "@/lib/api";
import { CATEGORY_LABELS, formatDate, readingTime } from "@/lib/format";
import { Kicker } from "./BreakingTag";

export function ArticleCard({ article, showImage = true, size = "md" }) {
  const to = `/artikel/${article.slug}`;
  return (
    <article data-testid={`article-card-${article.slug}`} className="group flex flex-col border-b border-edborder pb-5">
      {showImage && article.featured_image && (
        <Link to={to} className="block overflow-hidden mb-3 bg-edborder/40">
          <img
            src={resolveImg(article.featured_image)}
            alt={article.title}
            loading="lazy"
            className="w-full aspect-[16/10] object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          />
        </Link>
      )}
      <div className="flex items-center gap-2 mb-2">
        <Kicker breaking={article.is_breaking}>{article.kicker || CATEGORY_LABELS[article.category]}</Kicker>
        <span className="text-[11px] uppercase tracking-wide text-muted-foreground font-body">
          {CATEGORY_LABELS[article.category]}
        </span>
      </div>
      <Link to={to}>
        <h3 className={`font-headline font-bold text-prussian leading-snug group-hover:text-gold-hover transition-colors ${size === "lg" ? "text-2xl" : "text-lg"}`}>
          {article.title}
        </h3>
      </Link>
      {article.chapo && (
        <p className="mt-2 text-sm text-muted-foreground leading-relaxed line-clamp-2 font-body">
          {article.chapo}
        </p>
      )}
      <div className="mt-3 text-[11px] text-muted-foreground font-body uppercase tracking-wide">
        {article.author} · {formatDate(article.published_at)}
      </div>
    </article>
  );
}

export function ArticleRow({ article }) {
  const to = `/artikel/${article.slug}`;
  return (
    <article data-testid={`article-row-${article.slug}`} className="group flex gap-4 border-b border-edborder pb-4">
      {article.featured_image && (
        <Link to={to} className="shrink-0 w-28 h-20 overflow-hidden bg-edborder/40">
          <img src={resolveImg(article.featured_image)} alt={article.title} loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        </Link>
      )}
      <div className="min-w-0">
        <Kicker breaking={article.is_breaking}>{article.kicker || CATEGORY_LABELS[article.category]}</Kicker>
        <Link to={to}>
          <h3 className="font-headline font-bold text-prussian text-base leading-snug mt-1 group-hover:text-gold-hover transition-colors line-clamp-3">
            {article.title}
          </h3>
        </Link>
      </div>
    </article>
  );
}
